<div>
	<div class="modal-header">
		<h4 class="modal-title">Mettre à jour les droits du dossier {{folderName}}</h4>
		<button type="button" class="close" aria-label="Close" (click)="cancelDialog()"><span aria-hidden="true">&times;</span></button>
	</div>

	<div class="modal-body">
		<form [formGroup]="folderEditRightsForm" >
			<ul ngbNav #nav="ngbNav" [(activeId)]="active" class="nav-tabs">
				<li [ngbNavItem]="1" *ngIf="!this.folderEditRightsForm.controls['companiesControl'].disabled">
					<a ngbNavLink>Droits sociétés</a>
					<ng-template ngbNavContent>
						<div class="form-group">
							<label class="ls-label-strong" for="companies">Droits des sociétés</label>
							<p-listbox 
								id="companies"
								[options]="companiesList" 
								formControlName="companiesControl" 
								[metaKeySelection]="false" 
								[checkbox]="true" 
								[filter]="true" 
								[multiple]="true" 
								optionLabel="name"
								filterPlaceHolder="Nom de la société"
								[listStyle]="{'max-height': '10em'}">
							</p-listbox>
						</div>
					</ng-template>
				</li>

				<li [ngbNavItem]="2" *ngIf="!this.folderEditRightsForm.controls['usersControl'].disabled">
					<a ngbNavLink>Droits utilisateurs</a>
					<ng-template ngbNavContent>
						<div class="form-group">
							<label class="ls-label-strong">Droits propres des utilisateurs</label>
							<p-listbox 
								id="users"
								[options]="usersList" 
								formControlName="usersControl" 
								[metaKeySelection]="false" 
								[checkbox]="true" 
								[filter]="true" 
								[multiple]="true" 
								optionLabel="username"
								filterPlaceHolder="Identifiant de l'utilisateur"
								[listStyle]="{'max-height': '10em'}">
							</p-listbox>
						</div>
					</ng-template>
				</li>
			</ul>

			<div [ngbNavOutlet]="nav" class="mt-2"></div>
			<br>

			<div class="form-group">
				<input type="checkbox" formControlName="sendEmailControl" id="sendEmail"/>
				&nbsp;
				<label for="sendEmail" class="ls-label-strong">Envoyer le mail de lancement de projet aux nouveaux utilisateurs</label>
			</div>
		</form>
	</div>

	<div class="modal-footer">
		<button type="button" class="btn btn-light" (click)="cancelDialog()">Annuler</button>
		<button type="submit" class="btn btn-primary" [disabled]="!enableAction || !folderEditRightsForm.valid" (click)="save()">{{buttonText}}</button>
	</div>
</div>
